module.exports = __webpack_public_path__ + "img/icon-safe1.612f5bde.png";